export * from './shortcut.service';
